/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-06 16:27:04
 * @LastEditors: linxi
 * @LastEditTime: 2021-07-07 16:51:02
 */
import { API_PREFIX } from "./constant";
import { Request } from "./request";

export interface InventoryPriceParams {
  current?: number;
  executeDateEnd?: string;
  executeDateStart?: string;
  name?: string;
  size?: number;
  state?: number;
  tenantId?: number;
  tenantInventoryLedgerId?: number;
}

export interface InventoryPriceBody {
  beforeRetailPrice?: number;
  beforeUnitPrice?: number;
  executeDate?: string;
  id?: number;
  retailPrice?: number;
  state?: number;
  status?: number;
  tenantId?: number;
  tenantInventoryLedgerId?: number;
  unitPrice?: number;
  timeHead?: string;
  timeTail?: string;
}

export function InventoryPricePage(params: InventoryPriceParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/adjustprice/page`,
    method: "GET",
    params,
  };
}

export function InventoryPriceSubmit(body: InventoryPriceBody): Request {
  return {
    url: `${API_PREFIX}/blade-store/adjustprice/submitlist`,
    method: "POST",
    body,
  };
}

export function InventoryPriceRemove(ids: string): Request {
  return {
    url: `${API_PREFIX}/blade-store/adjustprice/remove`,
    method: "POST",
    params: {
      ids,
    },
  };
}

export function InventoryPriceTovoid(ids: string): Request {
  return {
    url: `${API_PREFIX}/blade-store/adjustprice/logoutlist`,
    method: "POST",
    params: {
      ids,
    },
  };
}

export function InventoryPriceImplement(ids: string): Request {
  return {
    url: `${API_PREFIX}/blade-store/adjustprice/executelist`,
    method: "POST",
    params: {
      ids,
    },
  };
}
